import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml: `A wave propagates from left to right and reaches the right boundary you selected. The velocity field and the pressure field can be displayed with arrows and colors respectively,or as a graph. The moving pair of microphones records the pressure and velocity as a function of time (graph below). You can play with the type of propagating wave and with the boundary condition. Feel free to pause the motion to freeze the situation, and move the microphones to examine the time evolution of pressure and velocity at any position. See how changing the boundary condition affects the pressure and velocity fields.\n<hr />\n <div style="display:flex;align-items:center;gap:10px">\n<i class="cil-comment-bubble-exclamation" style="font-size:21px"></i>\n<span style="font-size:10px;font-weight:700;line-height:16px">animation slowed down by 3000x, displacement multipled by 50000, medium: air, standing wave ratio: 7.32</span>\n</div>`,
  collapsibleDescription: true,
  collapsedDescriptionTextLines: 2,
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0105/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
